// frontend/src/services/visitCalendarService.js
import apiClient from '../utils/apiClient';
import { idempotentPatch } from '../utils/idempotentStockPosting';

export const fetchCalendarEvents = async ({ fromUTC, toUTC, employeeId, status }) => {
  const params = new URLSearchParams();
  params.set('fromUTC', fromUTC);
  params.set('toUTC', toUTC);
  if (employeeId != null && employeeId !== '') params.set('employeeId', String(employeeId));
  if (status) params.set('status', status);

  const url = `/visits/calendar?${params.toString()}`;
  const res = await apiClient.get(url, { withCredentials: true });
  return res.data;
};

export const updateVisitFromCalendar = async (visitId, payload) => {
  const patch = Object.prototype.hasOwnProperty.call(payload || {}, "checked") ? (url, body, config) => idempotentPatch(apiClient, url, body, config) : apiClient.patch.bind(apiClient);
  const res = await patch(`/visits/${visitId}/calendar`, payload, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
  });
  return res.data;
};

// (Optional) also provide default, so both import styles work
export default { fetchCalendarEvents, updateVisitFromCalendar };


